const customCssApi = ({ apiClient }) => ({
  list(params) {
    return apiClient.get(
      'custom-css',
      {},
      {
        ...params,
      },
      {},
    )
  },

  upsert(payload) {
    return apiClient.post('custom-css/upsert', payload, false, {})
  },

  show(id, param = {}) {
    return apiClient.get(`custom-css/${id}`, {}, param, {})
  },

  update(id, payload) {
    return apiClient.put(`custom-css/${id}`, payload, {})
  },

  delete(id) {
    return apiClient.delete(`custom-css/${id}`, {})
  },
})

export default customCssApi
